import { Component } from '@angular/core';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrl: './public-footer.component.scss'
})
export class PublicFooterComponent {


  scrollToTop(): void {
   // console.log("vers le haut");
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
